function FetchData(url, type, data) {
  const fetchOptions = {
    method: type,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    body: data,
    timeout: 8000
  };
  return fetch('/Home/' + url, fetchOptions).then(response => response.json());
}

export { FetchData }